"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDocumentReference = (value) => {
    if (!value) {
        return false;
    }
    return value.hasOwnProperty('firestore') ||
        (value.hasOwnProperty('_firestore') && value.hasOwnProperty('_path')) ||
        (Object.keys(value).length === 2 && value.hasOwnProperty('projectId') && value.hasOwnProperty('path'));
};
exports.isOption = (value) => {
    return Object.keys(value).length === 1 && value.hasOwnProperty('convertDocumentReference');
};
//# sourceMappingURL=util.js.map